var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('label', {
    attrs: {
      "id": "contract-Heading"
    }
  }, [_vm._v("Contract Template")]), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "title": "Back to Contract List"
    },
    on: {
      "click": _vm.showCreateContract
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "style": "font-size:18px"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Contract Template Name ")]), _c('span', {
    staticClass: "required"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-file-text' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contractname),
      expression: "contractname"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "contractname",
      "id": "contractname",
      "placeholder": "Enter Contract Name"
    },
    domProps: {
      "value": (_vm.contractname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contractname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.contractnameerr),
      expression: "contractnameerr"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.contractnameerr))])], 1)]), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('template1', {
    ref: "ContractChilds",
    attrs: {
      "selectedEdit": _vm.selectedEditRow
    },
    on: {
      "checkForContractValidation": _vm.checkForContractValidation,
      "goBackToCreateContract": _vm.saveContractService
    }
  })], 1)])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-033c4af6","hasScoped":true}!./src/modules/masterdata/views/contracttemplate/createContractTemplate/createContractTemplate.component.html
// module id = 668
// module chunks = 3